var render = function render() {
  var _vm$tagsSelectList, _vm$dataFrom$rights;
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.editIndex || _vm.editIndex === 0 ? _vm.$t("编辑") + _vm.$t("方案") : _vm.$t("新增") + _vm.$t("方案"),
      visible: _vm.dialogVisible,
      maskClosable: false,
      width: "75%"
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "formRef",
    staticClass: "plan-form",
    attrs: {
      model: _vm.dataFrom,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      },
      rules: _vm.dataRule
    }
  }, [_c("top-title", {
    staticStyle: {
      width: "100%"
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("方案信息")))])]), _c("a-form-model-item", {
    staticClass: "box2",
    attrs: {
      prop: "name",
      label: _vm.$t("方案名称")
    }
  }, [_c("a-input", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("方案名称")
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    staticClass: "box2",
    attrs: {
      label: _vm.$t("方案代码"),
      prop: "code"
    }
  }, [_c("a-input", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("方案代码")
    },
    model: {
      value: _vm.dataFrom.code,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "code", $$v);
      },
      expression: "dataFrom.code"
    }
  })], 1), _c("a-form-model-item", {
    ref: "templateRef",
    staticClass: "box2 label-box",
    attrs: {
      prop: "price",
      label: _vm.$t("保费")
    }
  }, [!_vm.isTemplate ? _c("a-input", {
    staticClass: "cont",
    staticStyle: {
      width: "calc(100% - 210px)",
      "margin-right": "10px"
    },
    attrs: {
      placeholder: _vm.$t("单位") + "：" + _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false))
    },
    on: {
      change: function ($event) {
        return _vm.dataFormChange("price");
      }
    },
    model: {
      value: _vm.dataFrom.price,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "price", $$v);
      },
      expression: "dataFrom.price"
    }
  }) : _vm._e(), _vm.isChina ? _c("a-checkbox", {
    staticStyle: {
      width: "200px",
      "white-space": "nowrap",
      "line-height": "32px",
      overflow: "hidden",
      "text-overflow": "ellipsis"
    },
    on: {
      change: _vm.changeIsTemplate
    },
    model: {
      value: _vm.isTemplate,
      callback: function ($$v) {
        _vm.isTemplate = $$v;
      },
      expression: "isTemplate"
    }
  }, [_c("a-tooltip", {
    attrs: {
      placement: "bottom",
      title: _vm.$t("创建区域保费模版")
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("创建区域保费模版")))])])], 1) : _vm._e()], 1), _c("a-form-model-item", {
    staticClass: "box2",
    attrs: {
      prop: "amount",
      label: _vm.$t("保障金额")
    }
  }, [_c("a-input", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("单位") + "：" + _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false))
    },
    on: {
      change: function ($event) {
        return _vm.dataFormChange("amount");
      }
    },
    model: {
      value: _vm.dataFrom.amount,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "amount", $$v);
      },
      expression: "dataFrom.amount"
    }
  })], 1), _c("a-form-model-item", {
    ref: "paymentDeadline",
    staticClass: "box2 deadline",
    attrs: {
      prop: "paymentDeadline",
      label: _vm.$t("缴费期限")
    }
  }, [_c("a-radio-group", {
    staticStyle: {
      display: "flex",
      width: "100%"
    },
    on: {
      change: _vm.onChange
    },
    model: {
      value: _vm.paymentDeadline,
      callback: function ($$v) {
        _vm.paymentDeadline = $$v;
      },
      expression: "paymentDeadline"
    }
  }, [_c("a-radio", {
    staticStyle: {
      width: "30%"
    },
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("趸交")))]), _c("a-radio", {
    staticStyle: {
      width: "70%"
    },
    attrs: {
      value: 1
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "30%",
      "margin-right": "10px"
    },
    attrs: {
      disabled: _vm.paymentDeadline !== 1,
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: function ($event) {
        _vm.onInput, _vm.paymentDeadlineCont = undefined;
      }
    },
    model: {
      value: _vm.paymentDeadlineType,
      callback: function ($$v) {
        _vm.paymentDeadlineType = $$v;
      },
      expression: "paymentDeadlineType"
    }
  }, _vm._l(_vm.PAYMENDEADLINE, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1), _c("a-input", {
    style: {
      width: "calc(70% - 30px)",
      marginLeft: 10
    },
    attrs: {
      placeholder: _vm.$t("请输入"),
      disabled: _vm.paymentDeadline == 1 ? false : true
    },
    on: {
      change: _vm.changeNumber
    },
    model: {
      value: _vm.paymentDeadlineCont,
      callback: function ($$v) {
        _vm.paymentDeadlineCont = $$v;
      },
      expression: "paymentDeadlineCont"
    }
  })], 1)], 1)], 1), _c("a-form-model-item", {
    ref: "age",
    staticClass: "box2",
    attrs: {
      label: _vm.$t("保障年龄"),
      prop: "age"
    }
  }, [_c("div", {
    staticClass: "cont"
  }, [_c("a-select", {
    staticStyle: {
      width: "30%",
      "margin-right": "20px"
    },
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode,
      dropdownClassName: "mul-select-dropdown"
    },
    on: {
      change: function ($event) {
        ;
        _vm.age1 = "", _vm.age2 = "", _vm.$refs.age.onFieldChange();
      }
    },
    model: {
      value: _vm.dataFrom.age.type,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom.age, "type", $$v);
      },
      expression: "dataFrom.age.type"
    }
  }, _vm._l(_vm.AGELIST, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1), _c("div", {
    staticClass: "infoBox",
    staticStyle: {
      width: "calc(70% - 20px)"
    }
  }, [_c("a-input", {
    style: _vm.dataFrom.age.type == 6 || _vm.dataFrom.age.type == 7 || _vm.dataFrom.age.type == 8 ? "width:100%" : "width: 45%",
    attrs: {
      placeholder: _vm.$t("请输入")
    },
    on: {
      blur: function ($event) {
        return _vm.$refs.age.onFieldChange();
      },
      change: function ($event) {
        return _vm.durationChange("age1");
      }
    },
    model: {
      value: _vm.age1,
      callback: function ($$v) {
        _vm.age1 = $$v;
      },
      expression: "age1"
    }
  }), _vm.dataFrom.age.type != 6 && _vm.dataFrom.age.type != 7 && _vm.dataFrom.age.type != 8 ? _c("div", {
    staticStyle: {
      width: "10px",
      height: "1px",
      background: "#d9d9d9",
      margin: "0 10px"
    }
  }) : _vm._e(), _vm.dataFrom.age.type != 6 && _vm.dataFrom.age.type != 7 && _vm.dataFrom.age.type != 8 ? _c("a-input", {
    staticStyle: {
      width: "45%"
    },
    attrs: {
      placeholder: _vm.$t("请输入")
    },
    on: {
      blur: function ($event) {
        return _vm.$refs.age.onFieldChange();
      },
      change: function ($event) {
        return _vm.durationChange("age2");
      }
    },
    model: {
      value: _vm.age2,
      callback: function ($$v) {
        _vm.age2 = $$v;
      },
      expression: "age2"
    }
  }) : _vm._e()], 1)], 1)]), _c("a-form-model-item", {
    staticClass: "box2",
    attrs: {
      prop: "occupation",
      label: _vm.$t("职业类别")
    }
  }, [_c("div", {
    staticClass: "cont"
  }, [_c("a-input", {
    attrs: {
      placeholder: "1" + _vm.$t("至") + "N" + _vm.$t("类") + "，" + _vm.$t("输入格式为") + "1,n;N" + _vm.$t("类") + "，" + _vm.$t("输入格式为") + "n,n"
    },
    model: {
      value: _vm.dataFrom.occupation,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "occupation", $$v);
      },
      expression: "dataFrom.occupation"
    }
  })], 1)]), _c("a-form-model-item", {
    ref: "duration",
    staticClass: "box2",
    attrs: {
      label: _vm.$t("保障期限"),
      prop: "duration"
    }
  }, [_c("div", {
    staticClass: "cont"
  }, [_c("a-select", {
    staticStyle: {
      width: "30%",
      "margin-right": "20px"
    },
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode,
      dropdownClassName: "mul-select-dropdown"
    },
    on: {
      change: function ($event) {
        ;
        _vm.duration1 = "", _vm.duration2 = "", _vm.$refs.duration.onFieldChange();
      }
    },
    model: {
      value: _vm.dataFrom.duration.type,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom.duration, "type", $$v);
      },
      expression: "dataFrom.duration.type"
    }
  }, _vm._l(_vm.termlist, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1), _c("div", {
    staticClass: "infoBox",
    staticStyle: {
      width: "calc(70% - 20px)"
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入"),
      disabled: _vm.dataFrom.duration.type == 5 ? true : false
    },
    on: {
      blur: function ($event) {
        return _vm.$refs.duration.onFieldChange();
      },
      change: function ($event) {
        return _vm.durationChange("duration1");
      }
    },
    model: {
      value: _vm.duration1,
      callback: function ($$v) {
        _vm.duration1 = $$v;
      },
      expression: "duration1"
    }
  }), _vm.dataFrom.duration.type == 2 || _vm.dataFrom.duration.type == 4 ? _c("div", {
    staticStyle: {
      width: "80px",
      height: "1px",
      background: "#d9d9d9",
      margin: "0 10px"
    }
  }) : _vm._e(), _vm.dataFrom.duration.type == 2 || _vm.dataFrom.duration.type == 4 ? _c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入")
    },
    on: {
      blur: function ($event) {
        return _vm.$refs.duration.onFieldChange();
      },
      change: function ($event) {
        return _vm.durationChange("duration2");
      }
    },
    model: {
      value: _vm.duration2,
      callback: function ($$v) {
        _vm.duration2 = $$v;
      },
      expression: "duration2"
    }
  }) : _vm._e()], 1)], 1)]), _c("a-form-model-item", {
    staticClass: "box2",
    attrs: {
      prop: "sex",
      label: _vm.$t("性别")
    }
  }, [_c("div", {
    staticClass: "cont"
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("无限制"),
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    model: {
      value: _vm.dataFrom.sex,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "sex", $$v);
      },
      expression: "dataFrom.sex"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("无限制")))]), _c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("男")))]), _c("a-select-option", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("女")))])], 1)], 1)]), _c("a-form-model-item", {
    staticClass: "box2",
    attrs: {
      prop: "socialSecurity",
      label: _vm.$t("社保")
    }
  }, [_c("div", {
    staticClass: "cont"
  }, [_c("a-select", {
    attrs: {
      placeholder: "无限制",
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    model: {
      value: _vm.dataFrom.socialSecurity,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "socialSecurity", $$v);
      },
      expression: "dataFrom.socialSecurity"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("无限制")))]), _c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("有")))]), _c("a-select-option", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("无")))])], 1)], 1)]), _c("a-form-model-item", {
    staticClass: "box2",
    attrs: {
      label: _vm.$t("等待期"),
      prop: "wait"
    }
  }, [_c("div", {
    staticClass: "cont"
  }, [_c("a-select", {
    staticStyle: {
      width: "30%",
      "margin-right": "20px"
    },
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: function ($event) {
        _vm.dataFrom.wait.value = undefined;
      }
    },
    model: {
      value: _vm.dataFrom.wait.type,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom.wait, "type", $$v);
      },
      expression: "dataFrom.wait.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("自然日")))]), _c("a-select-option", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("工作日")))])], 1), _c("div", {
    staticClass: "infoBox"
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("输入限制：单值（N）")
    },
    on: {
      change: function ($event) {
        return _vm.changeWait("wait");
      }
    },
    model: {
      value: _vm.dataFrom.wait.value,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom.wait, "value", $$v);
      },
      expression: "dataFrom.wait.value"
    }
  })], 1)], 1)]), _c("a-form-model-item", {
    staticClass: "box2",
    attrs: {
      label: _vm.$t("犹豫期"),
      prop: "hesitate"
    }
  }, [_c("div", {
    staticClass: "cont"
  }, [_c("a-select", {
    staticStyle: {
      width: "30%",
      "margin-right": "20px"
    },
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: function ($event) {
        _vm.dataFrom.hesitate.value = undefined;
      }
    },
    model: {
      value: _vm.dataFrom.hesitate.type,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom.hesitate, "type", $$v);
      },
      expression: "dataFrom.hesitate.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("自然日")))]), _c("a-select-option", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("工作日")))])], 1), _c("div", {
    staticClass: "infoBox"
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("输入限制：单值（N）")
    },
    on: {
      change: function ($event) {
        return _vm.changeWait("hesitate");
      }
    },
    model: {
      value: _vm.dataFrom.hesitate.value,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom.hesitate, "value", $$v);
      },
      expression: "dataFrom.hesitate.value"
    }
  })], 1)], 1)]), _c("a-form-model-item", {
    staticClass: "box2 label-box",
    attrs: {
      label: _vm.$t("方案标签"),
      prop: "tag"
    }
  }, [_c("div", {
    staticClass: "cont1"
  }, [_c("a-select", {
    staticStyle: {
      width: "30%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("分类"),
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: _vm.handleTagsChange
    },
    model: {
      value: _vm.tagsType,
      callback: function ($$v) {
        _vm.tagsType = $$v;
      },
      expression: "tagsType"
    }
  }, _vm._l(_vm.tagsList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: index
      }
    }, [_vm._v(" " + _vm._s(item.fieldKey) + " ")]);
  }), 1), _c("a-select", {
    staticStyle: {
      width: "calc(70% - 120px)",
      margin: "0 10px"
    },
    attrs: {
      placeholder: _vm.$t("先选择分类再选择属性"),
      disabled: _vm.disabledLabel,
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: _vm.handleTagsAttributeChange
    },
    model: {
      value: _vm.attributeID,
      callback: function ($$v) {
        _vm.attributeID = $$v;
      },
      expression: "attributeID"
    }
  }, _vm._l(_vm.tagsAttributeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: index
      }
    }, [_vm._v(" " + _vm._s(item.fieldFrontValue || item.fieldValue) + " ")]);
  }), 1), _c("span", {
    staticStyle: {
      width: "100px",
      height: "32px",
      "line-height": "32px",
      color: "#1890ff",
      cursor: "pointer"
    },
    style: _vm.disabled ? "color:#ccc;cursor: not-allowed" : "",
    on: {
      click: function ($event) {
        _vm.disabled = true;
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t("新增")))])], 1), _vm.disabled ? _c("div", {
    staticClass: "box",
    staticStyle: {
      "margin-top": "5px",
      width: ""
    }
  }, [_c("div", {
    staticClass: "cont"
  }, [_c("a-input", {
    staticStyle: {
      width: "calc(35% - 22px)"
    },
    attrs: {
      placeholder: _vm.$t("标签名称")
    },
    model: {
      value: _vm.tagObj.fieldKey,
      callback: function ($$v) {
        _vm.$set(_vm.tagObj, "fieldKey", $$v);
      },
      expression: "tagObj.fieldKey"
    }
  }), _c("a-input", {
    staticStyle: {
      margin: "0 10px",
      width: "calc(65% - 100px)"
    },
    attrs: {
      placeholder: _vm.$t("标签属性名称")
    },
    model: {
      value: _vm.tagObj.fieldValue,
      callback: function ($$v) {
        _vm.$set(_vm.tagObj, "fieldValue", $$v);
      },
      expression: "tagObj.fieldValue"
    }
  }), _c("div", {
    staticClass: "right"
  }, [_c("a-button", {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.addTagSave
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))]), _c("a-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function ($event) {
        ;
        _vm.disabled = false, _vm.tagObj.fieldKey = "", _vm.tagObj.fieldValue = "", _vm.$refs.formRef.clearValidate("tag");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("取消")))])], 1)], 1)]) : _vm._e(), ((_vm$tagsSelectList = _vm.tagsSelectList) === null || _vm$tagsSelectList === void 0 ? void 0 : _vm$tagsSelectList.length) != 0 ? _c("div", {
    staticClass: "box",
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap",
      "margin-top": "5px"
    }
  }, _vm._l(_vm.tagsSelectList, function (item) {
    return _c("a-tag", {
      key: item.fieldKey + item.fieldValue,
      attrs: {
        closable: ""
      },
      on: {
        close: () => _vm.handleClose(item)
      }
    }, [_vm._v(" " + _vm._s(item.fieldKey) + ":" + _vm._s(item.fieldFrontValue || item.fieldValue) + " ")]);
  }), 1) : _vm._e()]), _c("a-form-model-item", {
    staticClass: "box2",
    attrs: {
      label: _vm.$t("方案备注"),
      prop: "remark"
    }
  }, [_c("a-input", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("方案备注")
    },
    model: {
      value: _vm.dataFrom.remark,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "remark", $$v);
      },
      expression: "dataFrom.remark"
    }
  })], 1), _c("a-form-model-item", {
    staticClass: "box2",
    attrs: {
      label: _vm.$t("保障单位"),
      prop: "unit"
    }
  }, [_c("a-input", {
    staticClass: "cont",
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("保障单位")
    },
    model: {
      value: _vm.dataFrom.unit,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "unit", $$v);
      },
      expression: "dataFrom.unit"
    }
  })], 1)], 1), _vm.isTemplate ? _c("top-title", {
    staticStyle: {
      width: "100%"
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保费模版")))])]) : _vm._e(), _vm.isTemplate ? _c("add-premium-modal", {
    ref: "templateRef",
    attrs: {
      value: "premium",
      selected: _vm.selectedTerms,
      termsData: _vm.termsList,
      attachInfo: _vm.attachInfo,
      attachData: _vm.additionalList,
      premiumObj: _vm.premiumObj
    },
    on: {
      premiumData: _vm.getPremiumData
    }
  }) : _vm._e(), _c("top-title", {
    staticStyle: {
      width: "100%"
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保障权益")))])]), _c("a-form-model", {
    ref: "quanyiRef",
    staticClass: "plan-form2",
    attrs: {
      model: _vm.dataFrom,
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 20
      },
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    ref: "rights",
    staticClass: "box",
    class: ((_vm$dataFrom$rights = _vm.dataFrom.rights) === null || _vm$dataFrom$rights === void 0 ? void 0 : _vm$dataFrom$rights.length) > 1 ? "listBox" : "",
    attrs: {
      label: _vm.$t("保障权益"),
      prop: "rights"
    }
  }, _vm._l(_vm.dataFrom.rights, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "list"
    }, [_c("div", {
      staticClass: "cont"
    }, [_c("a-input", {
      staticStyle: {
        width: "20%"
      },
      style: item.name ? "border-color: #d9d9d9" : "",
      attrs: {
        placeholder: _vm.$t("保障权益")
      },
      on: {
        blur: function ($event) {
          return _vm.$refs.rights.onFieldChange();
        }
      },
      model: {
        value: item.name,
        callback: function ($$v) {
          _vm.$set(item, "name", $$v);
        },
        expression: "item.name"
      }
    }), _c("a-input", {
      staticStyle: {
        "margin-left": "20px",
        width: "20%"
      },
      style: item.value ? "border-color: #d9d9d9" : "",
      attrs: {
        placeholder: _vm.$t("保障金额")
      },
      on: {
        blur: function ($event) {
          return _vm.$refs.rights.onFieldChange();
        }
      },
      model: {
        value: item.value,
        callback: function ($$v) {
          _vm.$set(item, "value", $$v);
        },
        expression: "item.value"
      }
    }), _c("a-input", {
      staticStyle: {
        "margin-left": "20px",
        width: "60%",
        "border-color": "#d9d9d9"
      },
      attrs: {
        placeholder: _vm.$t("权益说明(选填)")
      },
      model: {
        value: item.info,
        callback: function ($$v) {
          _vm.$set(item, "info", $$v);
        },
        expression: "item.info"
      }
    })], 1), _c("div", {
      staticClass: "right"
    }, [index == 0 ? _c("a-button", {
      attrs: {
        type: "add"
      },
      on: {
        click: _vm.addRightsFun
      }
    }, [_vm._v(_vm._s(_vm.$t("添加")))]) : _c("a-button", {
      attrs: {
        type: "danger"
      },
      on: {
        click: function ($event) {
          return _vm.delRightsFun(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("删除")))])], 1)]);
  }), 0)], 1), _vm.additionalList.length != 0 ? _c("top-title", {
    staticStyle: {
      width: "100%"
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("附加险")))])]) : _vm._e(), _c("add-premium-modal", {
    attrs: {
      value: "additional",
      selected: _vm.selectedTerms,
      termsData: _vm.termsList,
      attachInfo: _vm.attachInfo,
      attachData: _vm.additionalList,
      premiumObj: _vm.premiumObj
    },
    on: {
      additionalData: _vm.getAdditionalData
    }
  }), _c("top-title", {
    staticStyle: {
      width: "100%"
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("方案条款")))])]), _c("add-premium-modal", {
    ref: "termsRef",
    attrs: {
      value: "clause",
      selected: _vm.selectedTerms,
      termsData: _vm.termsList,
      attachInfo: _vm.attachInfo,
      attachData: _vm.additionalList,
      premiumObj: _vm.premiumObj
    },
    on: {
      clauseData: _vm.getClauseData
    }
  }), _c("top-title", {
    staticStyle: {
      width: "100%"
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("健康告知")))])]), _c("a-checkbox", {
    staticStyle: {
      margin: "0 0 20px 20px"
    },
    attrs: {
      checked: _vm.dataFrom.generalHealthNotice == "true" || _vm.dataFrom.generalHealthNotice == true ? true : false
    },
    on: {
      change: _vm.changeHealthNotice
    }
  }, [_vm._v(_vm._s(_vm.$t("使用通用健康告知")))]), _vm.dataFrom.generalHealthNotice !== "true" ? _c("quill-editor", {
    staticStyle: {
      height: "200px",
      margin: "0 20px"
    },
    attrs: {
      options: _vm.quillOption
    },
    model: {
      value: _vm.dataFrom.healthNotice,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "healthNotice", $$v);
      },
      expression: "dataFrom.healthNotice"
    }
  }) : _vm._e(), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handleSure
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))]), !_vm.editIndex && _vm.editIndex !== 0 ? _c("a-checkbox", {
    model: {
      value: _vm.continueAdd,
      callback: function ($$v) {
        _vm.continueAdd = $$v;
      },
      expression: "continueAdd"
    }
  }, [_vm._v(_vm._s(_vm.$t("继续添加")))]) : _vm._e()], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };